export const SET_LOADING = 'SET_LOADING';
export const CALL_LOADING = 'CALL_LOADING';

export const setLoading = (loading: any) => ({
    type: SET_LOADING,
    loading,
});

const initialState = {
    loading: false
}

export const loadingReducer = (state = initialState, action: any) => {
    const { loading } = action;
    
    switch (action.type) {
        case SET_LOADING:
            return { ...state, loading};
        default:
            return state;
    }
}